import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from './assets/components/error/page-not-found.component';
import { LoginComponent } from './assets/components/login/login.component';
import { DashboardComponent } from './assets/components/dashboard/dashboard.component';
import { LeaveComponent } from './assets/components/leave/leave.component';
import { SalaryComponent } from './assets/components/salary/salary.component';
import { TaxesComponent } from './assets/components/taxes/taxes.component';
import { WebsitesComponent } from './assets/components/websites/websites.component';
import { MailComponent } from './assets/components/mail/mail.component';

const APP_ROUTES: Routes = [
    { path: '', component: LoginComponent },
    { path: 'dashboard', component: DashboardComponent },
    { path: 'leave', component: LeaveComponent },
    { path: 'salary', component: SalaryComponent },
    { path: 'taxes', component: TaxesComponent },
    { path: 'websites', component: WebsitesComponent },
    { path: 'mail', component: MailComponent },
    { path: '**', component: PageNotFoundComponent }
];

export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/app.routing.ts